import { ArsContextState, IArsActionSetSidebarWidth } from "../interface";

/**
 * Sets the sidebar width.
 *
 * @param state - Current ARS context state
 * @param action - Set-sidebar-width action
 * @returns Updated state with sidebar width changed
 */
export const arsc_setSidebarWidth = <T>(
  state: ArsContextState<T>,
  action: IArsActionSetSidebarWidth,
): ArsContextState<T> => ({
  ...state,
  currentSidebar: {
    ...state.currentSidebar,
    width: action.width,
  },
});
